import SummaryByDealer from "./summary-by-dealer.container";

export default SummaryByDealer;
